import { render, staticRenderFns } from "./spineView.vue?vue&type=template&id=5c75c0b3&scoped=true&"
import script from "./spineView.vue?vue&type=script&lang=js&"
export * from "./spineView.vue?vue&type=script&lang=js&"
import style0 from "./spineView.vue?vue&type=style&index=0&id=5c75c0b3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c75c0b3",
  null
  
)

export default component.exports